<script setup>
import { defineProps, computed, ref, onMounted, watch } from 'vue'
import PDFImageCard from '@/pages/global/pdfPreview/components/PDFImageCard.vue'
import sensor from '@utils/saUtilsGlobal'

const url = new URL(window.location.href)
const filename = url.searchParams.get('filename')

const props = defineProps({
  dataSource: {
    type: Object,
    default: () => ({})
  },
  loadTime: {
    type: Number
  },
  isRTL: {
    type: Boolean,
    default: false
  }
})

const innerLoadTime = computed(() => props.loadTime)
const innerPDFData = ref({})

/**
 * 将制定数组按照指定 size 分组
 * */
const handleGrouping = (arr, size) => {
  if (!arr || arr.length === 0) {
    return []
  }
  const result = []
  for (let i = 0; i < arr.length; i += size) {
    let group = arr.slice(i, i + size).map((item, idx) => ({
      ...item,
      originIndex: i + idx
    }))
    result.push(group)
  }
  return result
}

/**
 * 预览图片
 * */
const previewImageIndex = ref(0)
const show = ref(false)
const allImageList = ref([])

watch(
  () => props.dataSource,
  (newVal) => {
    if (!newVal) return
    const result = handleGrouping(newVal.content, 2)
    innerPDFData.value = {
      header: props.dataSource.header,
      content: result,
      countryCode: props.dataSource.countryCode,
      appLanguage: props.dataSource.appLanguage,
      pdfUrl: props.dataSource.pdfUrl
    }
    allImageList.value = props.dataSource.content?.map((item) => item.originUrl)
    handleTrack()
  }
)
const handlePreviewImage = (item) => {
  previewImageIndex.value = item.originIndex
  show.value = true
}

const handlePre = () => {
  previewImageIndex.value =
    previewImageIndex.value - 1 < 0 ? 0 : previewImageIndex.value - 1
}

const handleNext = () => {
  previewImageIndex.value =
    previewImageIndex.value + 1 > allImageList.value.length
      ? allImageList.value.length
      : previewImageIndex.value + 1
}

/**
 * 下载图片
 * */
const handleDownloadImg = async (e) => {
  e.stopPropagation()
  e.preventDefault()
  const response = await fetch(allImageList.value[previewImageIndex.value], {
    mode: 'cors'
  })
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = `${props.dataSource.header.title}_${
    props.dataSource.header.createDate
  }_${previewImageIndex.value + 1}.jpg`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(blobUrl)
}

const userImage = ref(null)
const scale = ref(1)
const handleOperateSmall = () => {
  scale.value = scale.value - 0.2 <= 0.5 ? 0.5 : scale.value - 0.2
}

const handleOperateBig = () => {
  scale.value = scale.value + 0.2 >= 2 ? 2 : scale.value + 0.2
  handleTrack2('photo')
}

const handleClickTimeLogo = () => {
  window.open('https://timemark.com/', '_blank')
  handleTrack2('timemark')
}
/**
 * 上报埋点信息
 * */
const handleTrack = (params) => {
  sensor.track('H5_enter_page_pdf_link', {
    loadResult: 'succ',
    loadTimeNum: innerLoadTime.value,
    photoNum: allImageList.value?.length,
    title: innerPDFData.value.header?.title,
    name: innerPDFData.value.header?.name,
    hasLogo: !!innerPDFData.value.header?.logoUrl,
    submitContent: allImageList.value?.map((item) =>
      item.split('?')[0].split('/').pop()
    ),
    pageNum: innerPDFData.value.content?.length,
    url: innerPDFData.value.pdfUrl,
    countryCode: innerPDFData.value.countryCode,
    appLanguage: innerPDFData.value.appLanguage,
    ...params
  })
}

const handleTrack2 = (clickItem, params) => {
  sensor.track('H5_click_page_pdf_link', {
    clickItem,
    ...params
  })
}
</script>

<template>
  <div :dir="isRTL ? 'rtl' : 'ltr'">
    <template
      v-for="(item, itemIndex) in innerPDFData.content"
      :key="itemIndex"
    >
      <div v-if="itemIndex === 0">
        <div class="firstPageTitle">
          <div class="title" :dir="isRTL ? 'rtl' : 'ltr'">
            <div class="left">
              <div class="div1">{{ innerPDFData.header.title }}</div>
              <div class="div2">{{ innerPDFData.header.createDate }}</div>
              <div v-if="innerPDFData.header.author" class="div3">
                {{ innerPDFData.header.author }}
              </div>
            </div>
            <div class="right" v-if="innerPDFData.header.logoUrl">
              <img :src="innerPDFData.header.logoUrl" alt="" />
            </div>
          </div>
          <div class="dividingLine">
            <hr />
          </div>
        </div>
        <!--        <div-->
        <!--          class="title"-->
        <!--          :style="{-->
        <!--            alignItems: innerPDFData.header.author ? 'center' : 'baseline'-->
        <!--          }"-->
        <!--        >-->
        <!--          <div class="left">-->
        <!--            <div class="leftLogo" v-if="innerPDFData.header.logoUrl">-->
        <!--              <img-->
        <!--                :style="{ width: '20px', height: '20px' }"-->
        <!--                :src="innerPDFData.header.logoUrl"-->
        <!--                alt=""-->
        <!--              />-->
        <!--            </div>-->
        <!--            <div class="leftTitle">{{ innerPDFData.header.title }}</div>-->
        <!--          </div>-->
        <!--          <div class="right">-->
        <!--            <span>{{ innerPDFData.header.createDate }}</span>-->
        <!--            <span v-if="innerPDFData.header.author">{{-->
        <!--              innerPDFData.header.author-->
        <!--            }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="pdf-content" :style="{ marginBottom: '10px' }">
        <PDFImageCard
          v-for="(i, index) in item"
          :key="`${itemIndex}-${index}`"
          :cardContent="i"
          @previewImage="handlePreviewImage"
          :isRTL="isRTL"
        />
        <div class="pdfFooter">
          <div class="timeLogo">
            <div
              :style="{ width: '16px', height: '16px' }"
              @click="handleClickTimeLogo"
            >
              <img
                @click="() => {}"
                :style="{ width: '100%', height: '100%' }"
                src="../assets/logo.png"
                alt=""
              />
            </div>
            <a href="https://timemark.com/" target="_blank">Timemark Camera</a>
          </div>
          <div class="page">
            {{ Number(itemIndex) + 1 }}
          </div>
        </div>
      </div>
      <van-image-preview
        class="pdfPreview"
        :dir="isRTL ? 'rtl' : 'ltr'"
        v-model:show="show"
        :images="allImageList"
        :showIndex="false"
        :closeable="true"
        :startPosition="previewImageIndex"
        :loop="false"
        :closeOnClickOverlay="false"
        :lazyLoad="true"
      >
        <template #image="{ src }">
          <div class="imgSlot">
            <div class="leftBtn" @click="handlePre">
              <img src="../assets/left.png" alt="" />
            </div>
            <div class="imgWrapper">
              <img
                ref="userImage"
                class="centerImg"
                loading="lazy"
                :style="{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  transform: `scale(${scale})`,
                  transition: 'transform 0.3s'
                }"
                :src="src"
              />
            </div>
            <div class="rightBtn" @click="handleNext">
              <img src="../assets/right.png" alt="" />
            </div>
          </div>
        </template>
        <template #cover>
          <div class="previewFooter">
            <img
              @click="handleDownloadImg"
              class="operateIcon"
              src="../assets/download.png"
              alt=""
            />
            <img
              @click="handleOperateSmall"
              class="small operateIcon"
              src="../assets/small.png"
              alt=""
            />
            <img
              @click="handleOperateBig"
              class="big operateIcon"
              src="../assets/big.png"
              alt=""
            />
          </div>
        </template>
      </van-image-preview>
    </template>
  </div>
</template>

<style scoped lang="scss">
.firstPageTitle {
  @media (min-width: 769px) {
    .title {
      box-sizing: border-box;
      background: #fff;
      display: flex;
      padding: 30px 40px 0 40px;

      .left {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        flex-grow: 1;
        width: 400px;

        .div1 {
          box-sizing: border-box;
          font-weight: 700;
          font-size: 20px;
          vertical-align: middle;
          word-wrap: break-word;
          word-break: break-word;
          white-space: normal;
          flex-shrink: 1;
          flex-grow: 1;
        }

        .div2,
        .div3 {
          margin-top: 6px;
          font-weight: 400;
          font-size: 12px;
          line-height: 100%;
        }
      }

      .right {
        margin-bottom: 10px;
        max-width: 90px;
        min-width: 70px;
        max-height: 50px;
        min-height: 48px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .dividingLine {
      background: #fff;
      padding-top: 10px;

      hr {
        border: none;
        height: 3px;
        background: #013dbe;
        margin: 0 40px;
      }
    }
  }

  @media (max-width: 769px) {
    .title {
      max-width: 100vw;
      box-sizing: border-box;
      background: #fff;
      display: flex;
      padding: 30px 24px 0 24px;

      .left {
        display: flex;
        flex-direction: column;
        flex-grow: 1;

        .div1 {
          display: flex;
          font-weight: 700;
          font-size: 20px;
          vertical-align: baseline;
          //flex-grow: 1;
          flex-shrink: 1;
          width: 95%;
          white-space: normal;
          word-break: break-word;
        }

        .div2,
        .div3 {
          margin-top: 6px;
          font-weight: 400;
          font-size: 12px;
          line-height: 100%;
        }
      }

      .right {
        margin-bottom: 10px;
        object-fit: contain;
        max-width: 120px;
        min-width: 70px;
        max-height: 70px;
        min-height: 48px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
    .dividingLine {
      background: #fff;
      padding: 10px 24px 0 24px;

      hr {
        border: none;
        height: 3px;
        background: #013dbe;
      }
    }
  }
}

.pdf-content {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
  position: relative;

  @media (min-width: 769px) {
    box-sizing: border-box;
    width: 612px;
    height: 792px;
    padding: 20px 40px 20px 40px;

    //.title {
    //  display: flex;
    //  justify-content: space-between;
    //  align-items: baseline;
    //
    //  .left {
    //    font-weight: 700;
    //    font-size: 32px;
    //    line-height: 100%;
    //    vertical-align: middle;
    //  }
    //
    //  .right {
    //    font-weight: 700;
    //    font-size: 16px;
    //    line-height: 21px;
    //    text-align: right;
    //    display: flex;
    //    flex-direction: column;
    //  }
    //}
    //
    //hr {
    //  height: 3px;
    //  background: #013dbe;
    //  margin: 10px 0 30px 0;
    //}
  }

  @media (max-width: 768px) {
    box-sizing: border-box;
    width: 100vw;
    height: 486px;
    background: #fff;
    padding: 20px 24px 20px 24px;

    //.title {
    //  display: flex;
    //  justify-content: space-between;
    //  align-items: baseline;
    //
    //  .left {
    //    font-weight: 700;
    //    font-size: 20px;
    //    line-height: 100%;
    //    vertical-align: middle;
    //  }
    //
    //  .right {
    //    font-weight: 700;
    //    font-size: 10px;
    //    line-height: 21px;
    //    text-align: right;
    //    display: flex;
    //    flex-direction: column;
    //  }
    //}
  }

  .pdfFooter {
    @media (min-width: 769px) {
      width: calc(100% - 80px);
      position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      .timeLogo {
        display: flex;
        align-items: center;
        height: 16px;
        gap: 4px;
      }
    }

    @media (max-width: 768px) {
      width: calc(100% - 50px);
      box-sizing: border-box;
      flex-grow: 1;
      position: absolute;
      bottom: 10px;
      display: flex;
      justify-content: space-between;
      .timeLogo {
        display: flex;
        align-items: center;
        height: 16px;
        gap: 4px;
      }
      .page {
        font-size: 11px;
      }
    }
  }
}
</style>

<style lang="scss">
.pdfPreview {
  &[dir='rtl'] {
    .leftBtn {
      order: 2;
    }

    .rightBtn {
      order: 1;
    }
  }

  .imgSlot {
    box-sizing: border-box;
    height: calc(100vh - 120px);
    display: flex;
    justify-content: center;
    width: 100vw;
    color: #fff;

    @media (min-width: 769px) {
      .leftBtn,
      .rightBtn {
        width: 50px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .imgWrapper {
        width: 100vw;
        object-fit: contain;
      }
    }

    @media (max-width: 769px) {
      .leftBtn,
      .rightBtn {
        display: none;
        //width: 30px;
        //height: 100%;
        //display: flex;
        //align-items: center;
        //justify-content: center;
        //cursor: pointer;
      }

      .imgWrapper {
        width: 100vw;
        object-fit: contain;
      }
    }
  }

  .previewFooter {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 50px;
    display: flex;
    justify-content: center;
    gap: 30px;
    padding-top: 10px;

    .operateIcon {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
